import {
  RPT_PRODUCT_LISTING_SET_DATA,
  RPT_PRODUCT_LISTING_ERROR,
  RPT_PRODUCT_LISTING_IS_LOADING,
  RPT_PRODUCT_LISTING_ON_SEARCH_CHANGE_DATA,
  RPT_PRODUCT_LISTING_CLEAN_UP
} from '../../../constants/index';
import { apiHelper } from '../../../utils/index';
import Cookies from 'js-cookie';
import { setErrorThunk, setLoadingStatus, setGetResults, setOnSearchChangeData, setOnCleanUpData } from '../actionHelper';

const API_URL = '/report/listing';

export const getAllRptProductData = (filterBy, sortBy, includeFilters = false) => dispatch => {
  dispatch(_getAllRptProductData(filterBy, sortBy, includeFilters));
};

const _getAllRptProductData = (filterBy, sortBy, includeFilters) =>
  apiHelper({
    url: `${API_URL}/product`,
    method: 'POST',
    data: {
      filterBy: filterBy,
      sortBy: sortBy,
      includeFilters: includeFilters
    },
    onLoad: status => setLoadingStatus(RPT_PRODUCT_LISTING_IS_LOADING, status),
    onSuccess: result => setGetResults(RPT_PRODUCT_LISTING_SET_DATA, result),
    onFailure: err => setErrorThunk(RPT_PRODUCT_LISTING_ERROR, true, err),
    accessToken: Cookies.get('accessToken')
  });

export const setOnSearchChange = retData => dispatch => {
  dispatch(setOnSearchChangeData(RPT_PRODUCT_LISTING_ON_SEARCH_CHANGE_DATA, retData));
};

export const setOnCleanUp = retData => dispatch => {
  dispatch(setOnCleanUpData(RPT_PRODUCT_LISTING_CLEAN_UP, retData));
};
